import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogViewPictureComponent } from './attach-files-dialog/attach-file-dialog-view-picture.component';
import { AttachFilesDialogComponent } from './attach-files-dialog/attach-files-dialog.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularMaterial } from '../../angular-material';
import { FocusDirective } from './directive/focus.directive';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AttachFilesComponent } from './attach-files/attach-files-dialog.component';
import { FileControllerComponent } from './file-controller/file-controller.component';
import { ButtonResponsiveDirective } from './directive/button-responsive.directive';
import { TypeDisplayDirective } from './directive/type-display.directive';
import { AutocompleteModule } from './autocomplete/autocomplete.component';
export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    DialogViewPictureComponent,
    FocusDirective,
    ButtonResponsiveDirective,
    TypeDisplayDirective,
    TimepickerComponent,
    AttachFilesComponent,
    FileControllerComponent,
    // AttachFilesDialogComponent
  ],
  imports: [
    HttpClientModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    AngularMaterial,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteModule,
  ],
  exports: [
    DialogViewPictureComponent,
    FocusDirective,
    ButtonResponsiveDirective,
    TypeDisplayDirective,
    AttachFilesComponent,
    TimepickerComponent,
    FileControllerComponent,
    AutocompleteModule,
    // AttachFilesDialogComponent
  ],
  providers: [],
})
export class SharedAllModule { }